import React from 'react';

interface AnswerButtonProps {
  label: string;
  answer: string;
  onClick: (answer: string) => void;
  disabled: boolean;
  state?: 'default' | 'correct' | 'wrong' | 'missed';
}

const AnswerButton: React.FC<AnswerButtonProps> = ({
  label,
  answer,
  onClick,
  disabled,
  state = 'default'
}) => {
  const getClassName = () => {
    let className = 'answer-btn';
    if (state === 'correct') className += ' answer-correct';
    else if (state === 'wrong') className += ' answer-wrong';
    else if (state === 'missed') className += ' answer-missed';
    return className;
  };

  return (
    <button
      className={getClassName()}
      onClick={() => onClick(answer)}
      disabled={disabled}
    >
      <span className="answer-label">{label}</span>
      <span className="answer-text">{answer}</span>
    </button>
  );
};

export default AnswerButton;
